import { render, staticRenderFns } from "./VirtualWalletCard.vue?vue&type=template&id=77820624&"
import script from "./VirtualWalletCard.vue?vue&type=script&lang=js&"
export * from "./VirtualWalletCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports